import type { OrganizationMember } from "../types/api";

/** Server cap on recipients per staff tag. */
export const MAX_NOTIFY_RECIPIENTS = 20;

/** GUIDs can come back from different sources in different cases. */
export const sameId = (a: string | null | undefined, b: string | null | undefined): boolean => {
  if (!a || !b) return false;
  return a.trim().toLowerCase() === b.trim().toLowerCase();
};

/** Nobody needs a notification about something they just did themselves. */
export const excludeSelf = (
  members: OrganizationMember[],
  selfUserId: string | null | undefined,
): OrganizationMember[] => members.filter((member) => !sameId(member.id, selfUserId));

/** "Alex", "Alex and Sam", "Alex, Sam and Jo". */
export const formatNameList = (names: string[]): string => {
  if (names.length <= 1) return names[0] ?? "";
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};

/**
 * The follow-up line after a send, naming everyone whose phone will not buzz. Null when every
 * recipient was reached. Same wording as mobile.
 */
export const buildNoAlertMessage = (
  noDeviceUserIds: string[],
  members: OrganizationMember[],
): string | null => {
  if (noDeviceUserIds.length === 0) return null;
  const names = noDeviceUserIds.map(
    (id) => members.find((member) => sameId(member.id, id))?.displayName ?? "One coach",
  );
  return `${formatNameList(names)} will not get a phone alert`;
};
